<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="店铺名称：" prop="nickName">
            <el-input style="width: 424px;" v-model="ruleForm.nickName" placeholder="请输入店铺名称"></el-input>
          </el-form-item>
          <el-form-item label="登录账号：" prop="userName">
            <el-input style="width: 424px;" v-model="ruleForm.userName" placeholder="请输入登录账号"></el-input>
            <div class="mt-warm-txt"><span>登录后台账号，英文或数字，不超过16位</span></div>
          </el-form-item>
          <el-form-item v-if="dataId == ''" label="登录密码：" prop="userPassword">
            <el-input style="width: 424px;" type="password" show-password v-model="ruleForm.userPassword" placeholder="请输入登录密码"></el-input>
            <div class="mt-warm-txt"><span>英文或数字，不少于6位</span></div>
          </el-form-item>
          <el-form-item label="是否默认：" prop="isDefault">
            <el-switch
              v-model="ruleForm.isDefault"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveTiYanDianUser, fetchTiYanDianUserDetailById, updateTiYanDianUser } from '@/api/experience'
import Editor from '@/components/Editor.vue'
export default {
  name: 'ExperienceShopAdd',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      dataId: this.$route.query.dataId,
      shopId:'',
      ruleForm: {
        nickName: '',
        userName: '',
        userPassword: '',
        isDefault:false,
        status: false,
        sort: ''
      },
      rules: {
        nickName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        userPassword: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (this.$route.query.dataId != ''){
      let that = this
      fetchTiYanDianUserDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.nickName = data.nickName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          let isDefault = false
          if (data.isDefault === 1) {
            isDefault = true
          }
          that.ruleForm.isDefault = isDefault
          that.ruleForm.userName = data.userName
          that.ruleForm.sort = data.sort
          that.shopId = data.shopId
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let nickName = that.ruleForm.nickName
      let shopId = that.shopId
      let status = that.ruleForm.status ? 1 : 0
      let isDefault = that.ruleForm.isDefault ? 1 : 0
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      let userName = that.ruleForm.userName
      let userPassword = that.ruleForm.userPassword
      if (nickName === '') {
        this.$message.error('请输入店铺名称')
        return false
      }
      if (userName === '') {
        this.$message.error('请输入登录账号')
        return false
      }
      if (userPassword == '' && dataId == '') {
        this.$message.error('请输入登录密码')
        return false
      }
      let passData = {
        nickName: nickName, status: status, isDefault: isDefault, sort: sort, userName: userName, userPassword: userPassword
      }
      if (dataId !== '') {
        passData.id = dataId;
        passData.shopId = shopId;
        updateTiYanDianUser(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveTiYanDianUser(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/experience/ShopAdd.vue